/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import { PageTitle } from '../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import { Col, Dropdown, Modal, Row, Spinner } from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import MasterServices from '../../../../services/master'
import { toast } from 'react-toastify'
import Api from '../../../../thesis-and-dissertations/helpers/api'
const api = new Api();

const heads = [
  {
    name: '',
    label: 'Judul Tugas Akhir',
  },
  {
    name: '',
    label: 'Published by',
  },
  {
    name: '',
    label: 'Kata Kunci',
  },
  {
    name: '',
    label: 'Key',
  },
  {
    name: '',
    label: 'Status',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const ThesisDisertationPage = () => {
  const [thesis, setThesis] = useState([])
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_row: 10,
  })

  const [show, setShow] = useState(false)
  const [formValue, setFormValue] = useState({})
  const [query, setQuery] = useState({});

  useEffect(() => {
    fetchThesis({ ...query })
  }, [query])

  const toggle = () => {
    if (show) {
      setFormValue({})
    }
    setShow(!show)
  }

  const fetchThesis = (params = {}) => {
    setIsLoading(true);
    api.getThesisAdmin({ ...params })
      .then(response => {
        setIsLoading(false);
        const data = response.data;

        let pagination = {};
        pagination.per_page = data.data.per_page;
        pagination.page = data.data.current_page;
        pagination.total_page = data.data.total;
        pagination.total_row = data.data.total;

        setThesis(data.data.data);
        setPagination(pagination);
      }).catch((error) => {
        const { data } = error.response;
        setErrors(data?.meta?.error);
        setIsLoading(false);
      });
  };

  const paginator = usePagination({
    totalCount: pagination?.total_row,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  const onChangePerPage = (per_page, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })

    fetchThesis({
      ...query,
      per_page: per_page,
      page: to_page,
    })
  }

  const handleChangeStatus = async (id, status) => {

    try {
      if (!window.confirm('Yakin ingin merubah status?')) {
        return
      }

      setIsLoading(true)
      await MasterServices.approveCompany({ status: status, id_tesis: id })
      toast.success(`Status Tesis Berhasil Diperbarui`)

    } catch (error) {
      setIsLoading(false)
    } finally {
      fetchThesis({ ...query, pagination })
    }
  }

  const ActionComponent = (item) => {
    return (
      <Dropdown>
        <Dropdown.Toggle
          id='dropdown-basic'
          className='btn btn-primary btn-sm'
        >
          {'  '}
          Aksi
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() => {
              setFormValue({
                Author: item.Author,
                Abstrak: item.Abstrak,
                JudulTugasAkhir: item.JudulTugasAkhir,
                KodeRegistrasi: item.KodeRegistrasi,
                email: item.email,
                Bahasa: item.Bahasa,
                BidangKeilmuan: item.BidangKeilmuan,
                katakunci: item.katakunci,
                tesis_status: item.tesis_status,
                TahunPublish: item.TahunPublish,
                Dokumen: item.Dokumen,
                publish_country: item.publish_country
              })

              toggle()
            }}
          >
            Lihat
          </Dropdown.Item>
          {item?.tesis_status != 1 && (
            <>
              <Dropdown.Item
                onClick={() => handleChangeStatus(item.Id, '1')}
              >
                Approve
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => handleChangeStatus(item.Id, '0')}
              >
                Reject
              </Dropdown.Item>
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>
    )
  }

  const StatusComponent = (type, obj) => {
    if (type === 'Ditolak') {
      return (
        <Button className='shadow-none btn btn-sm btn-outline btn-outline-danger' variant='outline'>
          {type}
        </Button>
      )
    }
    return (
      <Button className='shadow-none btn btn-sm btn-outline btn-outline-success' variant='outline'>
        {type}
      </Button>
    )
  }
  return (
    <>
      <div className='row'>
        <Modal show={show} onHide={toggle} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title>Detail Tesis</Modal.Title>
          </Modal.Header>
          <Form>
            <Modal.Body>
              <Row>

                <Col md={12}>
                  <Form.Group className={'mb-6'}>
                    <Form.Label>Judul</Form.Label>
                    <Form.Control
                      type='text'
                      name={'JudulTugasAkhir'}
                      value={formValue?.JudulTugasAkhir}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group className={'mb-6'}>
                    <Form.Label>Abstrak</Form.Label>
                    <Form.Control
                      name='Abstrak'
                      as='textarea'
                      value={formValue?.Abstrak}
                      rows={10}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className={'mb-6'}>
                    <Form.Label>Bahasa</Form.Label>
                    <Form.Control
                      type='text'
                      name={'JudulTugasAkhir'}
                      value={formValue?.Bahasa}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className={'mb-6'}>
                    <Form.Label>Bidang Keilmuan</Form.Label>
                    <Form.Control
                      type='text'
                      name={'JudulTugasAkhir'}
                      value={formValue?.BidangKeilmuan}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group className={'mb-6'}>
                    <Form.Label>Kata Kunci</Form.Label>
                    <Form.Control
                      type='text'
                      name={'JudulTugasAkhir'}
                      value={formValue?.katakunci?.map((item) => item?.KataKunci)}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group className={'mb-6'}>
                    <Form.Label>Author</Form.Label>
                    <Form.Control
                      type='text'
                      name={'Author'}
                      value={formValue?.Author}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group className={'mb-6'}>
                    <Form.Label>Tahun Publish</Form.Label>
                    <Form.Control
                      type='number'
                      name={'TahunPublish'}
                      value={formValue?.TahunPublish}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group className={'mb-6'}>
                    <Form.Label>Negara Penerbit</Form.Label>
                    <Form.Control
                      type='text'
                      name={'publish_country'}
                      value={formValue?.publish_country}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>

                <Col md={12} className={'mb-6'}>
                  <Row className='d-grid gap-4'>
                    <Col md={12}>
                      <Form.Label>Dokumen</Form.Label>
                    </Col>
                    {formValue?.Dokumen && formValue?.Dokumen ? (
                      <Col md={12}>
                        <a href={formValue?.Dokumen} target='_blank' >
                          {`File ${formValue?.JudulTugasAkhir}`}
                        </a>
                      </Col>
                    ) : null}

                  </Row>
                </Col>
              </Row>

            </Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' onClick={toggle}>
                Batalkan
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <div className='col-md-12'>
          <div className='card-custom'>
            <Row>
              <Col md={{ span: 4 }}>
                <Form.Control
                  placeholder='Cari...'
                  name='q'
                  onChange={(e) =>
                    setQuery({ ...query, JudulTugasAkhir: e.target.value })}
                />
              </Col>
              <Col md={{ span: 2, offset: 4 }} />
              <Col md={{ span: 2 }}>
                <Form.Select
                  aria-label='Default select example'
                  className='mr-8'
                  onChange={(e) => {
                    setQuery({ ...query, sort_order: e.target.value })
                  }}
                >
                  <option value='desc'>Terbaru</option>
                  <option value='asc'>Terlama</option>
                </Form.Select>
              </Col>
            </Row>

            <Row md={12} className='mt-8'>
              <Table responsive className='table-striped align-middle'>
                <thead>
                  <tr>
                    <th>#</th>
                    {heads.map((item, index) => (
                      <th key={index} style={{ maxWidth: item.label == 'Aksi' ? '100px' : '' }}>
                        {item.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>{
                  thesis?.map((item, key) => {
                    return (
                      <tr key={key}>
                        <td>{key + 1}</td>
                        <td>{item?.JudulTugasAkhir}</td>
                        <td>{item?.Author}</td>
                        <td>
                          {
                            item?.katakunci?.map((item, index) => {
                              return (
                                <span index={index}>{item?.KataKunci},</span>
                              )
                            })
                          }
                        </td>
                        <td>{item?.KodeRegistrasi}</td>
                        <td>{StatusComponent(item.status_approval)}</td>
                        <td>
                          {ActionComponent(item)}
                        </td>
                      </tr>
                    )
                  })
                }
                </tbody>
              </Table>
            </Row>

            <Row>
              <Col md={6}>
                {thesis?.length > 0 && !isLoading && (
                  <div style={{ float: 'left' }}>
                    <Dropdown>
                      <Dropdown.Toggle className='btn btn-sm'>
                        {pagination.per_page}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {[10, 25, 50, 100].map((item) => (
                          <Dropdown.Item
                            key={item}
                            onClick={() => onChangePerPage(item)}
                            disabled={pagination.per_page === item}
                          >
                            {item}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </Col>
              <Col md={6}>
                <div style={{ float: 'right' }}>
                  {!isLoading && (
                    <Pagination className='btn-sm'>
                      {paginator?.map((item) => {
                        return (
                          <Pagination.Item
                            className='btn-sm'
                            key={item}
                            active={item === pagination.page}
                            onClick={() => onChangePerPage(pagination.per_page, item)}
                            disabled={item === '...'}
                          >
                            {item}
                          </Pagination.Item>
                        )
                      })}
                    </Pagination>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

const ThesisDisertation = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Daftar Tesis & Disertasi
      </PageTitle>
      <ThesisDisertationPage />
    </>
  )
}

export default ThesisDisertation
